import Container from "@components/ui-old/container";
import Layout from "@components/layout/layout";
import PageHeader from "@components/ui-old/page-header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";
import React from "react";
import Accordion from "@components/ui/accordion-download";
import { useUploadCategoriesQuery, useUploadsByCategoryQuery, UploadItem } from "@framework/content/get-download";
import { useTranslation } from "next-i18next";
import { AnimatedNoContent } from "@components/other/no-content";
export default function Downloads() {
  const {
    t
  } = useTranslation();
  const {
    data: categories,
    isLoading,
    error
  } = useUploadCategoriesQuery();
  if (isLoading) {
    return <div className="py-16 lg:py-20 text-center"><p>{t("common:text-loading")}</p></div>;
  }
  if (error || !categories) {
    return <Container>
        <AnimatedNoContent />
      </Container>;
  }
  const accordionItems = categories?.map((category, index) => ({
    id: category.id ?? index,
    title: category.label,
    content: <UploadsList category={category.category} />
  })) || [];
  return <>
      <PageHeader pageHeader="text-page-downloads" data-sentry-element="PageHeader" data-sentry-source-file="downloads.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="downloads.tsx">
      <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4">
        {accordionItems.length > 0 ? <Accordion items={accordionItems} translatorNS="faq" /> : <AnimatedNoContent />}
      </div>
      </Container>
    </>;
}
Downloads.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common", "forms", "menu", "faq", "footer", 'swal']))
    }
  };
};
const UploadsList: React.FC<{
  category: string;
}> = ({
  category
}) => {
  const {
    t
  } = useTranslation();
  const {
    data: uploads,
    isLoading,
    error
  } = useUploadsByCategoryQuery(category);
  if (isLoading) {
    return <div><p>{t("common:text-loading")}</p></div>;
  }
  if (error || !uploads || uploads.length === 0) {
    return <Container>
        <AnimatedNoContent />
      </Container>;
  }
  return <ul className="list-disc pl-5" data-sentry-component="UploadsList" data-sentry-source-file="downloads.tsx">
      {uploads.map((upload: UploadItem) => <li key={upload.id} className="mb-2">
          <a href={upload.file} target="_blank" rel="noopener noreferrer" className="text-neutral-700 hover:underline">
            {upload.title}
          </a>
        </li>)}
    </ul>;
};